import React, { Component } from 'react';
import _ from 'lodash';

import ReactDOM from 'react-dom';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import utils from 'Utils/index.js';

import style from './style.scss';

import CallsListItem from '../../calls/CallsListItem/CallsListItem';
import LeadForm from '../LeadForm/LeadForm';

export default class LeadsListItem extends Component{

  constructor(props) {
    super(props);

    this.state = {
    };

  }


  componentWillReceiveProps(){

  }

  render() {

    const {lead, updateLead, removeLead, app_data, with_client, client} = this.props;

    const {app_data: {
      user: {
        access
      }
    }} = this.props;

    const date_formated = utils.format_date(new Date(lead.created_at), {
      with_time: true
    });

    const device_type = app_data.device_types[lead.device_type_id];
    const device_type_title = device_type ? device_type.title : '';

    const problem_type = app_data.problem_types[lead.problem_type_id];
    const problem_type_title = problem_type ? problem_type.title : '';

    const status = app_data.statuses[lead.status_id];
    const status_title = status ? status.title : '';

    const lead_is_order = (lead.remonline_id && lead.remonline_id);

    const lead_is_order_class = lead_is_order ? 'leads_table_is_order' : '';

    return (
      <tr key={lead.id} className={`${lead_is_order_class}`} onClick={() => updateLead(lead)}>

        <td className="leads_table__td leads_table__td_date">
          {date_formated}
        </td>

        {with_client &&
        <td className="leads_table__td">
          {lead.client ? lead.client.name : ''}
        </td>
        }

        {with_client &&
        <td className="leads_table__td">
          {lead.client ? lead.client.phone : ''}
        </td>
        }

        <td className="leads_table__td">
          {device_type_title} {problem_type_title} {status_title}
          <br/>
          {lead.model}
          <br/>
          {lead.comment}
        </td>

        <td className="leads_table__td" title={lead.remonline_data}>
          {lead.remonline_data}

          {access.leads.remove && <RemoveBtn
            onClick={(e) => {
              e.stopPropagation();
              removeLead(lead.id);
            }}
          />}

        </td>

        <td className="leads_table__td leads_table__td_act" title={lead.act_number}>
          <a href={`https://web.remonline.app/orders/table/${lead.remonline_id}`} target="_blank">{lead.act_number}</a>
        </td>

      </tr>
    )
  }
}

const RemoveBtn = ({onClick}) => {


  return <div className='button button_red button_big' onClick={onClick}>
    Удалить
  </div>;

};